import TableComponent from './TableComponent.vue'
export default TableComponent
